import Glide from '@glidejs/glide'

export default function slideshow () {
  const slideshowEl = document.querySelector('.Slideshow')

  if (slideshowEl) {
    const slideshowSlides = [...slideshowEl.querySelectorAll('.SlideshowSlide')]
    const slideshowBullets = slideshowEl.querySelector('.SlideshowBullets')
    let slideCount = 0

    slideshowSlides.forEach((slide) => {
      const button = document.createElement('button')
      button.classList.add('SlideshowBullets-bullet')
      button.dataset.glideDir = `=${slideCount}`
      slideCount++
      button.textContent = `${slideCount}`
      slideshowBullets.appendChild(button)
    })

    new Glide('.Slideshow', {
      perView: 2,
      gap: 150,
      peek: {
        before: 50,
        after: 100
      },
      breakpoints: {
        769: {
          perView: 1,
          gap: 50,
          peek: {
            before: 0,
            after: 0
          },
        }
      }
    }).mount()
  }
}
